import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions, Response} from '@angular/http';

import {Accounts} from './accounts';
import {TreeNode} from "primeng/api";

@Injectable()
export class AccountsService {

  constructor(private http: Http) {

  }

  getAll(page: number = 1, sort: string = '') {
    let currentfilter = JSON.parse(localStorage.getItem('filter'));
    if(!currentfilter) {
      currentfilter = {};
    }

    const params = new URLSearchParams();
    params.set('page',  page+'');
    params.set('sorts', sort);
    for (let key in currentfilter) {
      if(currentfilter[key]) {
        params.set('filter[' + key + ']', currentfilter[key])
      }
    }
    return this.http.get('accounts?' + params.toString()).map((response: Response) => response.json());
  }
    getAllGroups(_type : number = 0) {
        return this.http.get('accounts/lastaccounts/' + _type).map((response: Response) => response.json());
    }

  getAllGroups2(_type : number = 0) {
    return this.http.get('accounts/lastaccounts_balance/' + _type).map((response: Response) => response.json());
  }

  getAllAccounts() {
    return this.http.get('accounts/all').map((response: Response) => response.json());
  }
  getFullAccounts() {
    return this.http.get('accounts/full').map((response: Response) => response.json());
  }

  getParents() {
    return this.http.get('accounts/parent').map((response: Response) => response.json());
  }

  getAllGroups_exept(_id: string) {
    return this.http.get('accounts/all_exept/' + _id).map((response: Response) => response.json());
  }
  
  getDocs(_doc: number) {
    return this.http.get('accounts/doc_list/' + _doc).map((response: Response) => response.json());
  }

  getById(_id: string) {
    console.log('accounts/' + _id);
    return this.http.get('accounts/' + _id).map((response: Response) => response.json());
  }

  getfilantype(_id: string) {
    //console.log('accounts/getfinaltype/' + _id);
    return this.http.get('accounts/getfinaltype/' + _id).map((response: Response) => response.json());
  }
  checklast(_id: string) {
    //console.log('accounts/getfinaltype/' + _id);
    return this.http.get('accounts/checklast/' + _id).map((response: Response) => response.json());
  }

  getTree(_id:string) {
    return this.http.get('accounts/tree/' + _id).toPromise().then(res => <TreeNode[]> res.json());
  }
  getTrashedById(_id: string) {
    return this.http.get('accounts/trashed/' + _id).map((response: Response) => response.json());
  }
  restoreTrashedById(_id: string) {
    return this.http.put('accounts/trashed/' + _id,{}).map((response: Response) => response.json());
  }

  create(accounts: Accounts) {
    return this.http.post('accounts', accounts).map((response: Response) => response.json());
  }

  update(accounts: Accounts) {
    return this.http.put('accounts/' + accounts.id, accounts).map((response: Response) => response.json());
  }

  delete(_id: string) {
    return this.http.delete('accounts/' + _id).map((response: Response) => response.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/views/fin/accounts/accounts.service.ts